"use strict";
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.License = exports.Info = exports.Contact = void 0;
const codegen_1 = require("@azure-tools/codegen");
class Contact extends codegen_1.Initializer {
    constructor(initializer) {
        super();
        this.apply(initializer);
    }
}
exports.Contact = Contact;
class Info extends codegen_1.Initializer {
    constructor(title, initializer) {
        super();
        this.title = title;
        this.apply(initializer);
    }
}
exports.Info = Info;
class License extends codegen_1.Initializer {
    constructor(name, initializer) {
        super();
        this.name = name;
        this.apply(initializer);
    }
}
exports.License = License;
//# sourceMappingURL=info.js.map